var _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    className: "symbol",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 20,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 16,
    x2: 24,
    y2: 64,
    stroke: "#000",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 16,
    x2: 56,
    y2: 64,
    stroke: "#000",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.60da61ad888499cbe079ade84b5db063.svg";
export { ForwardRef as ReactComponent };